var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-field"},[_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}}),_c('span',{staticClass:"underline"})])}
var staticRenderFns = []

export { render, staticRenderFns }